angular.module('impactx.lot').directive('ixLotUsage', function ()
{
    return {
        scope: {
            usageData : "="
        },
        restrict: 'E',
        templateUrl: 'modules/lot/templates/lotusage.tmpl.html',
        transclude: true
    };
});